module.exports = __webpack_public_path__ + "media/flags/ca-33a9f69e.svg";